import { useNavigate } from "react-router-dom";
import "./Hanbook.css";

const HANDBOOKS = [
  {
    id: "hb-1",
    title: "Safety & Health Handbook — 2026",
    url: "https://jum-email-signature.s3.us-east-2.amazonaws.com/-%2BFor%2BUse%2B2026%2BSafety%2Band%2BHealth%2BHandbook%2B2026%2B112525LL.pdf",
  },
  {
    id: "hb-2",
    title: "Employee Handbook — 2026",
    url: "https://jum-email-signature.s3.us-east-2.amazonaws.com/Employee+Handbook.pdf",
  },
];

export default function Handbooks() {
  const navigate = useNavigate();

  function openViewer(handbook) {
    // navigate to the PdfViewer route and pass handbook data via state
    navigate("/handbook-pdf", {
      state: { title: handbook.title, url: handbook.url },
    });
  }

  return (
    <div className="handbook-list-root">
      <header className="handbook-list-header">
        <img src="../assets/logo.svg" alt="JAXUM" className="handbook-logo" />
        <div className="handbook-header-text">
          <h1>Jaxum Handbooks</h1>
          <p className="handbook-list-sub">
            Official PDFs and reference materials
          </p>
        </div>
      </header>

      <section className="handbook-list-grid">
        {HANDBOOKS.map((hb) => (
          <article key={hb.id} className="handbook-card">
            <div className="handbook-card-title">{hb.title}</div>
            <div className="handbook-card-actions">
              <button className="button primary" onClick={() => openViewer(hb)}>
                Open
              </button>
              <a className="button" href={hb.url} download>
                Download
              </a>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
